import { useErrorHandler } from "../../../../app-utils/graphql/useError.js";
import type { GetArrayElementType, GraphqlLazyResult } from "../../../../types.d.ts";
import {
  type GetQuickSearchSuggestionsLazyQueryHookResult,
  type GetQuickSearchSuggestionsQuery,
  type GetQuickSearchSuggestionsQueryVariables,
  useGetQuickSearchSuggestionsLazyQuery,
} from "./search.gql.js";

export type QuickSearchSuggestionsLazyResults = NonNullable<
  NonNullable<GetQuickSearchSuggestionsQuery["search"]>["globalSearch"]
>["categories"];
export type QuickSearchSuggestionsLazyResult = GetArrayElementType<NonNullable<QuickSearchSuggestionsLazyResults>>;
export type QuickSearchSuggestionsCategory = GetArrayElementType<
  NonNullable<NonNullable<QuickSearchSuggestionsLazyResult>["items"]>
>;

export const useQuickSearchSuggestionsLazy = (): GraphqlLazyResult<
  GetQuickSearchSuggestionsQueryVariables,
  GetQuickSearchSuggestionsLazyQueryHookResult,
  QuickSearchSuggestionsLazyResults
> => {
  const [search, { data, loading, error }] = useGetQuickSearchSuggestionsLazyQuery();

  // if `throwError: true`, the redirect doesn't happen. In fact nothing happens.
  const handleError = useErrorHandler();

  const action = async (variables: GetQuickSearchSuggestionsQueryVariables) => {
    try {
      const result = await search({ variables });

      if (result.error) {
        throw result.error;
      }

      return result;
    } catch (error) {
      throw await handleError(error);
    }
  };

  return [action, { data: data?.search?.globalSearch?.categories, loading, error }];
  // return [(variables) => search({ variables }), { data: data?.search?.globalSearch?.categories, loading, error }];
};
